import React from 'react';
import { func, object, string, bool } from 'prop-types';
import { AsyncKovResourcePicker, useLoadSriOptions } from '@kathondvla/react-shared-components/src';
import { sriClient } from 'ReduxLoop/utils/apiConfig';
import { printDate } from '@kathondvla/sri-client/date-utils';
import customStyle from './customStyle';

const OuWithAddressPicker = ({ path, value, searchParameter, parameters, onSelect, onInputChange, showInstitutionNumber, className, disabled }) => {
  const sriLoadOptionsFn = useLoadSriOptions({
    sriClient,
    href: path,
    parameters,
    searchParameter,
  });

  const onChangeHandler = (option) => {
    if (option) {
      onSelect(option.$$expanded || option);
    }
  };

  const resourcePickerOptions = {
    className,
    value,
    onChange: (optionSelected) => onChangeHandler(optionSelected),
    placeholder: 'zoek op naam of op gemeente',
    clearable: false,
    menuShouldScrollIntoView: false,
    onInputChange,
    optionValue: (option) => option.key || option.$$expanded?.key,
    optionTemplate: (option) => <CustomTemplate option={option.$$expanded || option} showInstitutionNumber={showInstitutionNumber} />,
    style: customStyle,
    loadOptions: sriLoadOptionsFn,
    disabled,
  };

  return <AsyncKovResourcePicker {...resourcePickerOptions} />;
};

// eslint-disable-next-line no-unused-vars
const CustomTemplate = ({ option, showInstitutionNumber }) => (
  <div className="picker-result author">
    <strong className="title">{option.name || option.$$displayName}</strong>
    {showInstitutionNumber && (option.institutionNumber || option.companyNumber || option.vatNumber) && (
      <span style={{ display: 'inline-block', textAlign: 'center', width: '1em', color: 'darkgray' }}>•</span>
    )}
    {showInstitutionNumber && (option.institutionNumber || option.companyNumber || option.vatNumber) && (<span  style={{ color: 'darkgray' }}>{option.institutionNumber || option.companyNumber || option.vatNumber}</span>)}
    {option.endDate && (<div className="subtitle"> [beëindigd sinds {printDate(option.endDate)}]</div>)}
    {option.mailAddresses && option.mailAddresses.length > 0 && (
      <div className="subtitle" style={{ fontSize: '12px', marginTop: '-4px' }}>
        {option.mailAddresses[0].address.street} {option.mailAddresses[0].address.houseNumber}{' '}
        {', '}
        {option.mailAddresses[0].address.zipCode} {option.mailAddresses[0].address.subCity}
      </div>
    )}
    {!(option.mailAddresses && option.mailAddresses.length > 0) &&
      option.locations &&
      option.locations.map((location) => (
        <div
          key={location.permalink}
          className="subtitle"
          style={{ fontSize: '12px', marginTop: '-4px' }}
        >
          {location.address.street} {location.address.houseNumber} {', '}
          {location.address.zipCode} {location.address.subCity}
        </div>
      ))}
  </div>
);

OuWithAddressPicker.propTypes = {
  className: string,
  value: object,
  path: string,
  parameters: object,
  searchParameter: string,
  showInstitutionNumber: bool,
  onSelect: func,
  onInputChange: func,
  disabled: bool,
};

export default OuWithAddressPicker;
